import { noop } from '@datadog/browser-core';
import { RumEventType } from '../rawRumEvent.types';
export function trackEventCounts(_ref) {
  var lifeCycle = _ref.lifeCycle,
      isChildEvent = _ref.isChildEvent,
      _ref$onChange = _ref.onChange,
      callback = _ref$onChange === void 0 ? noop : _ref$onChange;
  var eventCounts = {
    errorCount: 0,
    longTaskCount: 0,
    resourceCount: 0,
    actionCount: 0,
    frustrationCount: 0
  };
  var subscription = lifeCycle.subscribe(13
  /* LifeCycleEventType.RUM_EVENT_COLLECTED */
  , function (event) {
    var _a;

    if (event.type === 'view' || event.type === 'vital' || !isChildEvent(event)) {
      return;
    }

    switch (event.type) {
      case RumEventType.ERROR:
        eventCounts.errorCount += 1;
        callback();
        break;

      case RumEventType.ACTION:
        eventCounts.actionCount += 1;

        if (event.action.frustration) {
          eventCounts.frustrationCount += event.action.frustration.type.length;
        }

        callback();
        break;

      case RumEventType.LONG_TASK:
        eventCounts.longTaskCount += 1;
        callback();
        break;

      case RumEventType.RESOURCE:
        if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
          eventCounts.resourceCount += 1;
          callback();
        }

        break;
    }
  });
  return {
    stop: function stop() {
      subscription.unsubscribe();
    },
    eventCounts: eventCounts
  };
}